export default "__VITE_ASSET__CpkdRteK__"